import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningRed = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M724.196 0h-424.391l-299.804 299.804v424.391l299.804 299.804h424.391l299.804-299.804v-424.391l-299.804-299.804zM512 813.511c-40.96 0-73.956-32.996-73.956-73.956s32.996-73.956 73.956-73.956c40.96 0 73.956 32.996 73.956 73.956s-32.996 73.956-73.956 73.956zM568.889 512c0 31.419-25.47 56.889-56.889 56.889s-56.889-25.47-56.889-56.889v-227.556c0-31.419 25.47-56.889 56.889-56.889s56.889 25.47 56.889 56.889v227.556z",
		fill: "rgb(235, 87, 87)"
	})
});
const ForwardRef = forwardRef(SvgWarningRed);
export default ForwardRef;
